import { render, staticRenderFns } from "./identity.vue?vue&type=template&id=7c5bac7c&scoped=true&"
import script from "./identity.vue?vue&type=script&lang=js&"
export * from "./identity.vue?vue&type=script&lang=js&"
import style0 from "./identity.vue?vue&type=style&index=0&id=7c5bac7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5bac7c",
  null
  
)

export default component.exports